import { useState } from "react";

import { getLabel } from "../../tools/Dictionary";

import "./TagInput.css";

const TagInput = (props) => {

  //Props
  const ReadOnly = props.ReadOnly;
  const Tag = props.Tag;
  const OnChangeValue = props.OnChangeValue;
  //If True, will keep case, otherwise will change it to lowercase
  const KeepCase = props.KeepCase;

  //State
  const [tag, setTag] = useState(Tag || []);
  const [form, setForm] = useState("");

  const handleKeyDown = (e) =>
  {
    if (e.key === 'Enter' && form.trim())
    {
      e.preventDefault();
      const newValue = [...tag, KeepCase ? form.trim() : form.trim().toLowerCase()];
      setTag(newValue);
      OnChangeValue(newValue);
      setForm('');
      
    } else if (e.key === 'Backspace' && !form && tag.length > 0)
    {
      const newValue = tag.slice(0, -1);
      setTag(newValue);
      OnChangeValue(newValue);
    }
  };

  const removeTag = (_index) => {

    let newValue = tag.filter((_, index) => index !== _index);
  
    setTag(newValue);
    OnChangeValue(newValue);
  };



  return (
    <div className="taginput_container">
      <div className="taginput_input_container page_noselect">
        {tag.map((t, index) => (
          <span key={index} className="taginput_tag">
            {t}
            {!ReadOnly &&
              <button 
                onClick={() => removeTag(index)}
                className="taginput_remove_button"
              >
                x
              </button>
            }
          </span>
        ))}
        <input
          type="text"
          value={form}
          onChange={(e) => setForm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="taginput_input"
          placeholder={tag.length === 0 ? getLabel("TagInput", "Type and press Enter to add tags") : ""}
          readOnly={ReadOnly}
        />
      </div>
    </div>
  );

}


export default TagInput;